import React from 'react';
import { mui } from '~/tools/mui';
import { jss } from '~/tools/jss';

const useStyles = jss.makeStyles((theme) => ({
  spinner: {
    color: theme.palette.primary.main,
  },
  root: {
    position: 'relative',
    height: '100%',
    width: '100%',
  },
  centered: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
  },
}));

type LoadingProps = {
  height?: number;
  containerHeight?: string;
  show?: boolean;
  centered?: boolean;
  className?: string;
};

const Loading = ({ height = 55, containerHeight, show = false, centered = true, className = '' }: LoadingProps) => {
  const styles = useStyles();

  if (!show) return null;

  // TODO: Change how the container margins work without using `height * 2` so
  // it is more configurable and flexible.
  return (
    <div
      data-testid="loading"
      className={jss.combineStyles(styles.root, className)}
      style={{ height: containerHeight || height * 2 }}
    >
      <div className={jss.combineStyles({ [styles.centered]: centered })}>
        <mui.CircularProgress size={height} className={styles.spinner} />
      </div>
    </div>
  );
};

export default Loading;
